<h2 mat-dialog-title class="modal-title">
  <mat-icon class="title-icon">delete_forever</mat-icon>
  Delete Item
</h2>

<mat-dialog-content class="modal-content">
  <p class="warning-intro">
    Are you sure you want to delete this item? This action <strong>cannot be undone</strong>.
  </p>

  <!-- Target item -->
  <div class="preview-section">
    <div class="section-label">Item to delete</div>
    <div class="target-item">
      <span class="photo-type-badge">{{ data.target.photo_type | titlecase }}</span>
      <span class="item-description">{{ data.target.brand }} — {{ data.target.item }}</span>
      <span class="item-filename">{{ data.target.image_name.split('/').pop() }}</span>
    </div>
  </div>

  <!-- Sibling photos -->
  <div class="preview-section" *ngIf="data.sibling_photos.length > 0">
    <div class="section-label">
      <mat-icon class="section-icon">photo_library</mat-icon>
      {{ data.sibling_photos.length }} related photo{{ data.sibling_photos.length > 1 ? 's' : '' }} will also be deleted
    </div>
    <ul class="related-list">
      <li *ngFor="let photo of data.sibling_photos">
        <span class="photo-type-badge">{{ photo.photo_type | titlecase }}</span>
        <span class="item-filename">{{ photo.image_name.split('/').pop() }}</span>
      </li>
    </ul>
  </div>

  <!-- Session entries -->
  <div class="preview-section" *ngIf="data.session_entries.length > 0">
    <div class="section-label">
      <mat-icon class="section-icon">folder_shared</mat-icon>
      {{ data.session_entries.length }} session {{ data.session_entries.length > 1 ? 'entries' : 'entry' }} will be removed
    </div>
    <ul class="related-list">
      <li *ngFor="let entry of data.session_entries">
        <span class="item-description">{{ entry.brand }} — {{ entry.item }}</span>
        <span class="item-filename">{{ entry.image_name.split('/').pop() }}</span>
      </li>
    </ul>
  </div>

  <!-- Summary -->
  <div class="delete-summary">
    <mat-icon class="summary-icon">info_outline</mat-icon>
    <span>
      Total: <strong>{{ data.total_photos_to_delete }} photo{{ data.total_photos_to_delete !== 1 ? 's' : '' }}</strong>
      and <strong>{{ data.total_session_entries_to_delete }} session {{ data.total_session_entries_to_delete !== 1 ? 'entries' : 'entry' }}</strong> will be permanently removed.
    </span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button mat-stroked-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="warn" (click)="confirm()">Delete</button>
</mat-dialog-actions>
